/**
 * Inline, for a failure that *is* the page's content (AI Dude being down).
 * Results of a request — saved, failed — are toasts; see `lib/toast.ts`.
 */
export function AlertError({ message }: { message: string }) {
  return <p className="alert-error">{message}</p>;
}
